export default __webpack_public_path__ + "static/media/IMG_5238.95f00bcd.PNG";